mutation updateLeadsPipelineStatusPosition($input: UpdateLeadsPipelineStatusPositionInput!) {
  updateLeadsPipelineStatusPosition(input: $input) {
    id
    companyId
    name
    position
  }
}
